const LogRocket = require("logrocket");
exports.onClientEntry = () => {
    LogRocket.init(process.env.GATSBY_LOG_ROCKET_ID);
};
